import React from 'react';

// Skeleton loading component for the featured post
export const SkeletonFeaturedPost = () => (
  <div className="bg-neutral-900 rounded-2xl overflow-hidden flex flex-col md:flex-row border border-neutral-800 animate-pulse">
    <div className="md:w-1/2 p-6 md:p-8 flex flex-col">
      <div className="mb-2">
        <div className="flex flex-wrap gap-2 mb-3">
          <div className="w-20 h-5 bg-neutral-800 rounded-full"></div>
        </div>
        <div className="h-8 bg-neutral-800 rounded mb-2 w-4/5"></div>
        <div className="h-8 bg-neutral-800 rounded mb-3 w-3/5"></div>
        <div className="h-4 bg-neutral-800 rounded mb-1 w-full"></div>
        <div className="h-4 bg-neutral-800 rounded mb-1 w-full"></div>
        <div className="h-4 bg-neutral-800 rounded mb-4 w-2/3"></div>
      </div>
      <div className="mt-auto">
        <div className="flex items-center mb-4">
          <div className="text-sm flex items-center">
            <div className="w-32 h-4 bg-neutral-800 rounded mr-2"></div>
            <div className="w-28 h-4 bg-neutral-800 rounded"></div>
          </div>
        </div>
        <div className="w-24 h-4 bg-neutral-800 rounded mb-4"></div>
        <div className="w-32 h-9 bg-neutral-800 rounded-md"></div>
      </div>
    </div>
    <div className="md:w-1/2 relative">
      <div className="w-full h-64 md:h-full bg-neutral-800"></div>
      <div className="absolute bottom-4 right-4 bg-black/70 w-20 h-5 rounded"></div>
    </div>
  </div>
);

// Skeleton loading component for regular post cards
export const SkeletonPostCard = () => (
  <div className="bg-neutral-900 border border-neutral-800 rounded-md overflow-hidden h-full animate-pulse">
    <div className="relative">
      <div className="w-full h-48 bg-neutral-800"></div>
      <div className="absolute bottom-2 right-2 bg-black/70 w-16 h-5 rounded"></div>
    </div>
    <div className="p-4">
      <div className="h-6 bg-neutral-800 rounded mb-2 w-4/5"></div>
      <div className="h-6 bg-neutral-800 rounded mb-2 w-3/5"></div>
      
      <div className="flex items-center mb-2">
        <div className="w-24 h-3 bg-neutral-800 rounded mr-2"></div>
        <div className="w-20 h-3 bg-neutral-800 rounded"></div>
      </div>
      
      <div className="h-3 bg-neutral-800 rounded mb-1 w-full"></div>
      <div className="h-3 bg-neutral-800 rounded mb-3 w-4/5"></div>
      
      <div className="w-20 h-4 bg-neutral-800 rounded"></div>
    </div>
  </div>
);

// Replace with a simple loading indicator
export const BlogListSkeleton = () => (
  <div className="flex justify-center items-center py-16">
    <div className="loader text-[#00CF9D] flex items-center">
      <svg className="animate-spin mr-3 h-8 w-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <span>Loading content...</span>
    </div>
  </div>
);

// Skeleton for single post page
export const SinglePostSkeleton = () => (
  <div className="w-full overflow-x-hidden pt-16 bg-black animate-pulse">
    <article className="max-w-4xl mx-auto px-8 sm:px-8 md:px-12 py-16 sm:py-2 mt-20">
      <div className="mb-8">
        <div className="w-32 h-5 bg-neutral-800 rounded mb-8"></div>
        
        <div className="h-10 bg-neutral-800 rounded mb-2 w-4/5"></div>
        <div className="h-10 bg-neutral-800 rounded mb-4 w-3/5"></div>
        
        <div className="w-full flex items-center mb-8">
          <div className="w-36 h-4 bg-neutral-800 rounded mr-2"></div>
          <div className="w-28 h-4 bg-neutral-800 rounded mr-2"></div>
          <div className="w-4 h-4 bg-neutral-800 rounded-full mx-2"></div>
          <div className="w-24 h-4 bg-neutral-800 rounded"></div>
        </div>
      </div>
      
      <div className="w-full h-[300px] bg-neutral-800 rounded-lg mb-10"></div>
      
      <div className="flex flex-wrap gap-2 mb-10">
        <div className="w-20 h-6 bg-neutral-800 rounded-full"></div>
        <div className="w-24 h-6 bg-neutral-800 rounded-full"></div>
        <div className="w-16 h-6 bg-neutral-800 rounded-full"></div>
      </div>
      
      <div className="space-y-4 mb-10">
        <div className="h-5 bg-neutral-800 rounded w-full"></div>
        <div className="h-5 bg-neutral-800 rounded w-full"></div>
        <div className="h-5 bg-neutral-800 rounded w-4/5"></div>
        <div className="h-5 bg-neutral-800 rounded w-full"></div>
        <div className="h-5 bg-neutral-800 rounded w-3/4"></div>
        <div className="h-5 bg-neutral-800 rounded w-full"></div>
        <div className="h-5 bg-neutral-800 rounded w-5/6"></div>
        <div className="h-5 bg-neutral-800 rounded w-full"></div>
        <div className="h-5 bg-neutral-800 rounded w-2/3"></div>
      </div>
      
      <div className="mt-16 pt-8 border-t border-neutral-800">
        <div className="bg-neutral-900 rounded-lg border border-neutral-800 p-6 mb-8">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="w-16 h-16 bg-neutral-800 rounded-full"></div>
            
            <div className="flex-1">
              <div className="h-6 bg-neutral-800 rounded mb-2 w-40"></div>
              <div className="h-4 bg-neutral-800 rounded mb-2 w-32"></div>
              <div className="h-4 bg-neutral-800 rounded mb-4 w-full"></div>
              
              <div className="flex flex-wrap gap-3">
                <div className="w-20 h-6 bg-neutral-800 rounded"></div>
                <div className="w-20 h-6 bg-neutral-800 rounded"></div>
                <div className="w-24 h-6 bg-neutral-800 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-8 pt-8 border-t border-neutral-800">
        <div className="w-36 h-10 bg-neutral-800 rounded-md"></div>
      </div>
    </article>
  </div>
);

// Static versions of skeleton loaders for error states
export const StaticSkeletonFeaturedPost = () => (
  <div className="bg-neutral-900 rounded-2xl overflow-hidden flex flex-col md:flex-row border border-neutral-800 opacity-50">
    <div className="md:w-1/2 p-6 md:p-8 flex flex-col">
      <div className="mb-2">
        <div className="flex flex-wrap gap-2 mb-3">
          <div className="w-20 h-5 bg-neutral-800 rounded-full"></div>
        </div>
        <div className="h-8 bg-neutral-800 rounded mb-2 w-4/5"></div>
        <div className="h-8 bg-neutral-800 rounded mb-3 w-3/5"></div>
        <div className="h-4 bg-neutral-800 rounded mb-1 w-full"></div>
        <div className="h-4 bg-neutral-800 rounded mb-1 w-full"></div>
        <div className="h-4 bg-neutral-800 rounded mb-4 w-2/3"></div>
      </div>
      <div className="mt-auto">
        <div className="flex items-center mb-4">
          <div className="text-sm flex items-center">
            <div className="w-32 h-4 bg-neutral-800 rounded mr-2"></div>
            <div className="w-28 h-4 bg-neutral-800 rounded"></div>
          </div>
        </div>
        <div className="w-24 h-4 bg-neutral-800 rounded mb-4"></div>
        <div className="w-32 h-9 bg-neutral-800 rounded-md"></div>
      </div>
    </div>
    <div className="md:w-1/2 relative">
      <div className="w-full h-64 md:h-full bg-neutral-800"></div>
      <div className="absolute bottom-4 right-4 bg-black/70 w-20 h-5 rounded"></div>
    </div>
  </div>
);

export const StaticSkeletonPostCard = () => (
  <div className="bg-neutral-900 border border-neutral-800 rounded-md overflow-hidden h-full opacity-50">
    <div className="relative">
      <div className="w-full h-48 bg-neutral-800"></div>
      <div className="absolute bottom-2 right-2 bg-black/70 w-16 h-5 rounded"></div>
    </div>
    <div className="p-4">
      <div className="h-6 bg-neutral-800 rounded mb-2 w-4/5"></div>
      <div className="h-6 bg-neutral-800 rounded mb-2 w-3/5"></div>
      
      <div className="flex items-center mb-2">
        <div className="w-24 h-3 bg-neutral-800 rounded mr-2"></div>
        <div className="w-20 h-3 bg-neutral-800 rounded"></div>
      </div>
      
      <div className="h-3 bg-neutral-800 rounded mb-1 w-full"></div>
      <div className="h-3 bg-neutral-800 rounded mb-3 w-4/5"></div>
      
      <div className="w-20 h-4 bg-neutral-800 rounded"></div>
    </div>
  </div>
);

// Remove the StaticBlogListSkeleton component completely or replace with a simple message
export const StaticBlogListSkeleton = () => (
  <div className="text-center py-8">
    <p className="text-neutral-400">Content unavailable.</p>
  </div>
);

export const StaticSinglePostSkeleton = () => (
  <div className="w-full overflow-x-hidden pt-16 bg-black opacity-50">
    <article className="max-w-4xl mx-auto px-8 sm:px-8 md:px-12 py-16 sm:py-2 mt-20">
      <div className="mb-8">
        <div className="w-32 h-5 bg-neutral-800 rounded mb-8"></div>
        
        <div className="h-10 bg-neutral-800 rounded mb-2 w-4/5"></div>
        <div className="h-10 bg-neutral-800 rounded mb-4 w-3/5"></div>
        
        <div className="w-full flex items-center mb-8">
          <div className="w-36 h-4 bg-neutral-800 rounded mr-2"></div>
          <div className="w-28 h-4 bg-neutral-800 rounded mr-2"></div>
          <div className="w-4 h-4 bg-neutral-800 rounded-full mx-2"></div>
          <div className="w-24 h-4 bg-neutral-800 rounded"></div>
        </div>
      </div>
      
      <div className="w-full h-[300px] bg-neutral-800 rounded-lg mb-10"></div>
      
      <div className="flex flex-wrap gap-2 mb-10">
        <div className="w-20 h-6 bg-neutral-800 rounded-full"></div>
        <div className="w-24 h-6 bg-neutral-800 rounded-full"></div>
        <div className="w-16 h-6 bg-neutral-800 rounded-full"></div>
      </div>
      
      <div className="space-y-4 mb-10">
        <div className="h-5 bg-neutral-800 rounded w-full"></div>
        <div className="h-5 bg-neutral-800 rounded w-full"></div>
        <div className="h-5 bg-neutral-800 rounded w-4/5"></div>
        <div className="h-5 bg-neutral-800 rounded w-full"></div>
        <div className="h-5 bg-neutral-800 rounded w-3/4"></div>
        <div className="h-5 bg-neutral-800 rounded w-full"></div>
        <div className="h-5 bg-neutral-800 rounded w-5/6"></div>
        <div className="h-5 bg-neutral-800 rounded w-full"></div>
        <div className="h-5 bg-neutral-800 rounded w-2/3"></div>
      </div>
      
      <div className="mt-16 pt-8 border-t border-neutral-800">
        <div className="bg-neutral-900 rounded-lg border border-neutral-800 p-6 mb-8">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="w-16 h-16 bg-neutral-800 rounded-full"></div>
            
            <div className="flex-1">
              <div className="h-6 bg-neutral-800 rounded mb-2 w-40"></div>
              <div className="h-4 bg-neutral-800 rounded mb-2 w-32"></div>
              <div className="h-4 bg-neutral-800 rounded mb-4 w-full"></div>
              
              <div className="flex flex-wrap gap-3">
                <div className="w-20 h-6 bg-neutral-800 rounded"></div>
                <div className="w-20 h-6 bg-neutral-800 rounded"></div>
                <div className="w-24 h-6 bg-neutral-800 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-8 pt-8 border-t border-neutral-800">
        <div className="w-36 h-10 bg-neutral-800 rounded-md"></div>
      </div>
    </article>
  </div>
); 